import ResetZoom from './ResetZoom';

export default ResetZoom;